export default __webpack_public_path__ + "116af9e226ed7b6dbb14141ac81312d4.jpg";